import {
  UserDetailFormValues,
  UserEditFormValues,
  UserPasswordEditFormValues,
  UserPermissionEditFormValues,
  UserPermissionSearchFormValues,
  UserRole,
  UserSearchFormValues,
} from "./types";


export const initialUserDetailForm: UserDetailFormValues = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  mobilePhoneNumber: "",
  oib: null,
  userName: "",
  password: "",
  addressCity: "",
  addressCountry: "",
  addressLine1: "",
  addressLine2: "",
  addressPostalCode: null,
  addressState: "",
  officeId: null,
  roles: [],
};


export const initialUserEditForm: UserEditFormValues = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  mobilePhoneNumber: "",
  oib: null,
  userName: "",
  password: "",
  confirmPassword: "",
  addressCity: "",
  addressCountry: "",
  addressLine1: "",
  addressLine2: "",
  addressPostalCode: null,
  addressState: "",
  officeId: null,
  roles: [],
};

export const initialUserPasswordEditFormValues: UserPasswordEditFormValues = {
  password: "",
  confirmPassword: "",
};

export const initialUserSearchForm: UserSearchFormValues = {
  search: "",
  roleId: null,
  email: "",
  phone: "",
  address: "",
};


export const initialUserRole: UserRole = {
  id: "",
  name: "",
  isAdmin: false,
  isSystem: false
};



export const initialUserPermissionEditForm: UserPermissionEditFormValues = {
  name: "",
  enabled: false,
};

export const initialUserPermissionSearchForm: UserPermissionSearchFormValues = {
  search: null,
  categoryIds: [],
  includeSubcategories: false,
  assignmentFilter: "all",
};